export default __webpack_public_path__ + "static/media/blue-cross-blue-shield-logo.746aac65.png";